import React from 'react';
import styles from './CountryLanguageItem.module.scss';
import cx from 'classnames';
import { ItemLabel } from '../../ItemLabel/ItemLabel';
import { Text } from '../../Typography/Text/Text';
import { IconFlag } from '../../Icons/IconFlag/IconFlag';
import { Row, RowCell } from '../../Row/Row';
import { TranslateMessage } from 'src/components/shared/Translations/TranslateMessage/TranslateMessage';
import { TranslationId } from '../../../../utils/translation.generated';

export interface Props {
  className?: string;
  countryClassName?: string;
  languageClassName?: string;
  showLanguage?: boolean;
  languageOnRight?: boolean;
  size?: 'medium' | 'small';
  countryTranslationKey: TranslationId;
  languageTranslationKey: TranslationId;
  countryCode: string;
}

const CountryLanguageItem: React.FC<Props> = ({
  languageOnRight,
  showLanguage,
  size,
  className,
  countryClassName,
  languageClassName,
  countryTranslationKey,
  countryCode,
  languageTranslationKey,
}) => {
  const classNames = cx(styles.item, className, {
    [styles[`item_size-${size}`]]: size,
    [styles.item_languageOnRight]: languageOnRight,
  });

  const countryClassNames = cx(styles.country, countryClassName);
  const languageClassNames = cx(styles.language, languageClassName);

  const item = (
    <ItemLabel
      className={classNames}
      iconEl={
        <IconFlag country={countryCode} size={size === 'small' ? 16 : 24} />
      }
      title={
        <Text className={countryClassNames}>
          <TranslateMessage id={countryTranslationKey} />
        </Text>
      }
      {...(!languageOnRight &&
        showLanguage && {
          subTitle: (
            <Text className={languageClassNames}>
              <TranslateMessage id={languageTranslationKey} />
            </Text>
          ),
        })}
      noSidePaddings
    />
  );

  if (!languageOnRight) {
    return item;
  }

  return (
    <Row
      align={'center'}
      margin={'no'}
      gaps={'narrow'}
      noSideGaps
      className={classNames}
    >
      <RowCell>{item}</RowCell>
      {showLanguage && (
        <RowCell auto className={languageClassNames}>
          <TranslateMessage id={languageTranslationKey} />
        </RowCell>
      )}
    </Row>
  );
};

export { CountryLanguageItem };
